import { render, staticRenderFns } from "./DeliveryPdf.vue?vue&type=template&id=b5a88226&"
import script from "./DeliveryPdf.vue?vue&type=script&lang=js&"
export * from "./DeliveryPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports